import { useAppDispatch, useAppSelector } from "@app/hooks"
import { CourseClassRegistrationClient } from "@clients/courseClassRegistrationClient"
import { registerStudentToCourseUpdated } from "@features/program/programSlice"
import CourseClassRegistrationPopup from "./courseClassRegistrationPopup"

function RegisterStudentToCourseClassPopup() {
  const model = useAppSelector(
    (state) => state.program.studentsPage.registerStudentToCourseClassPopup,
  )
  const dispatch = useAppDispatch()

  const onClose = () => dispatch(registerStudentToCourseUpdated(undefined))

  return (
    <CourseClassRegistrationPopup
      model={model}
      title={
        model ? `Register ${model.firstName} ${model.lastName} to a course` : ""
      }
      confirmText="Register"
      onClose={onClose}
      onConfirm={({ courseClassId, studentId, userClientId }) =>
        CourseClassRegistrationClient.registerStudentToClassManually(
          courseClassId,
          studentId,
          new Date(),
          userClientId,
        )
      }
    />
  )
}

export default RegisterStudentToCourseClassPopup
